// ui/src/config/api.js

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://47.251.43.229:35001';


const CLEAN_BASE_URL = API_BASE_URL.endsWith('/') 
    ? API_BASE_URL.slice(0, -1)
    : API_BASE_URL;
export const API_ENDPOINTS = {
  UPDATE_VIEWS: `${CLEAN_BASE_URL}/api/update-views`,
  PROFILE_UPDATE: `${CLEAN_BASE_URL}/api/profile/update`,
  PROFILE_AVATAR: `${CLEAN_BASE_URL}/api/profile/avatar`,
  PROFILE_GET: (userId) => `${CLEAN_BASE_URL}/api/profile/${userId}`,
  PROFILE_ME: `${CLEAN_BASE_URL}/api/profile/me`,
  
    CLEAN_BASE_URL: CLEAN_BASE_URL 
};

export default API_ENDPOINTS;